import { createFileRoute, Outlet, useSearch } from '@tanstack/react-router';

import { ContinuityPlansSubNav } from '@/features/bcp/continuity-plans/ContinuityPlansSubNav';
import { getContinuitySection } from '@/features/bcp/continuity-plans/config';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/plans')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.continuityPlans'),
  }),
  component: BCPPlansLayout,
});

function BCPPlansLayout() {
  const search = useSearch({ strict: false });
  const searchSection = (search as Record<string, unknown>).section;
  const sectionFromSearch = typeof searchSection === 'string' ? searchSection : undefined;
  const section = getContinuitySection(sectionFromSearch);

  return (
    <div className="flex min-h-[calc(100vh-4rem)] flex-col md:flex-row">
      <ContinuityPlansSubNav activeSection={section.key} />
      <main className="min-w-0 flex-1">
        <Outlet />
      </main>
    </div>
  );
}
